export const employeeSubTypes = {
  fullTime: 'full_time',
  fixedTerm: 'fixed_term',
} as const;

export const employeeSubTypeLabels: Record<string, string> = {
  [employeeSubTypes.fullTime]: 'Full Time',
  [employeeSubTypes.fixedTerm]: 'Fixed Term',
};

export const employeeSubTypeFilterOptions = [
  { key: employeeSubTypes.fullTime, value: employeeSubTypeLabels[employeeSubTypes.fullTime] },
  { key: employeeSubTypes.fixedTerm, value: employeeSubTypeLabels[employeeSubTypes.fixedTerm] },
];

export const employeeSubTypeActionListOptions = [
  { value: employeeSubTypes.fullTime, title: employeeSubTypeLabels[employeeSubTypes.fullTime] },
  { value: employeeSubTypes.fixedTerm, title: employeeSubTypeLabels[employeeSubTypes.fixedTerm] },
];

export const employeeSubTypeBadges: Record<string, { label: string; color: 'information' | 'neutral' }> = {
  [employeeSubTypes.fixedTerm]: {
    label: employeeSubTypeLabels[employeeSubTypes.fixedTerm],
    color: 'information',
  },
  [employeeSubTypes.fullTime]: {
    label: employeeSubTypeLabels[employeeSubTypes.fullTime],
    color: 'neutral',
  },
};
